import { useCMSPageField } from '@/cms/fields'
import { CatalogueType } from '@/config/types'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'

type RegionsSection = 'regions' | 'other_regions'

type TemplateType = 'country' | 'region'

const regionTagsSetByTemplateType: Record<TemplateType, Record<RegionsSection, Record<CatalogueType, string>>> = {
  country: {
    regions: {
      summer: 'destination_country_regions_title__summer',
      winter: 'destination_country_regions_title__winter',
    },
    other_regions: {
      summer: 'destination_country_other_regions_title__summer',
      winter: 'destination_country_other_regions_title__winter',
    },
  },
  region: {
    regions: {
      summer: 'destination_region_regions_title__summer',
      winter: 'destination_region_regions_title__winter',
    },
    other_regions: {
      summer: 'destination_region_other_regions_title__summer',
      winter: 'destination_region_other_regions_title__winter',
    },
  },
}

export function useRegionsTitleKey(section: RegionsSection): string {
  const template = useCMSPageField('template')
  const publicationCode = useConfiguration('publicationCode')

  const templateType: TemplateType = template === 'CountryPage' ? 'country' : 'region'
  const season = PublicationCodes.isSunwebWinterPublicationCode(publicationCode) ? 'winter' : 'summer'

  return regionTagsSetByTemplateType[templateType][section][season]
}
